import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AntTag } from '@agro-club/agroclub-shared'
import { Bid } from 'modules/domain/bid/types'

export const BidTypeTag: FC<{ bid: Bid }> = ({ bid }) => {
  const { t } = useTranslation('bid')
  return <AntTag color="white">{t(`bidTypes.${bid.bid_type}`)}</AntTag>
}
